module.exports = __webpack_public_path__ + "static/media/stroke.671fb6f0.jpg";